import React, { createContext, Fragment, useContext, useEffect, useState } from "react";
import { CartLoader, CardScanLoader, HourglassLoader, DotsLoader, LockLoader } from "../Layout/Common/flashLoaders";
import { usePageVisible } from "../utils/pageVisibility";

const FlashLoaderIcon = DotsLoader;

const FlashScreenContext = createContext(null);

const useFlashScreen = () => useContext(FlashScreenContext);

const FlashScreenProvider = ({ children }) => {
  const [flashScreen, setFlashScreenState] = useState(null);
  const [flashMessages, setFlashMessages] = useState([]);
  const [flashInterval, setFlashInterval] = useState(2500);
  const [flashMessageIndex, setFlashMessageIndex] = useState(0);
  const [flashFadeOut, setFlashFadeOut] = useState(false);
  const pageVisible = usePageVisible();

  const showFlashScreen = (input) => {
    if (input && typeof input === "object" && Array.isArray(input.messages)) {
      setFlashMessages(input.messages);
      setFlashInterval(
        input.interval && typeof input.interval === "number" && input.interval > 0 ? input.interval : 2500,
      );
      setFlashMessageIndex(0);
      setFlashFadeOut(false);
      setFlashScreenState(true);
      return;
    }
    if (input === true) {
      setFlashMessages([]);
      setFlashMessageIndex(0);
      setFlashFadeOut(false);
      setFlashScreenState(true);
      return;
    }
    setFlashMessages([]);
    setFlashMessageIndex(0);
    setFlashFadeOut(false);
    setFlashScreenState(input);
  };

  useEffect(() => {
    if (flashScreen !== true || flashMessages.length <= 1 || !pageVisible) return;
    const fadeDuration = 400;
    let swapTimeout;
    const tick = setInterval(() => {
      setFlashFadeOut(true);
      swapTimeout = setTimeout(() => {
        setFlashMessageIndex((i) => (i + 1) % flashMessages.length);
        setFlashFadeOut(false);
      }, fadeDuration);
    }, flashInterval);
    return () => {
      clearInterval(tick);
      if (swapTimeout) clearTimeout(swapTimeout);
    };
  }, [flashScreen, flashMessages, flashInterval, pageVisible]);

  return (
    <FlashScreenContext.Provider value={{ showFlashScreen }}>
      {children}
      <Fragment>
        {flashScreen === true && (
          <div id="paymentFlashPanel" className="paymentFlashScreen">
            {flashMessages.length > 0 && (
              <div className="flashScreen-content">
                <FlashLoaderIcon />
                <div className={"flashScreen-text" + (flashFadeOut ? " is-fading" : "")}>
                  {flashMessages[flashMessageIndex]}
                </div>
              </div>
            )}
          </div>
        )}
      </Fragment>
    </FlashScreenContext.Provider>
  );
};

export { FlashScreenContext, FlashScreenProvider, useFlashScreen };
